import React, { useState } from "react";

const Card_Mission = ({ cardData }) => {
  const [viewMoreStates, setViewMoreStates] = useState(
    Array(cardData.cards.length).fill(false)
  );

  const toggleViewMore = (index) => {
    setViewMoreStates((prevStates) =>
      prevStates.map((state, i) => (i === index ? !state : state))
    );
  };

  return (
    <div className="w-full flex justify-center mt-5">
      <div className="w-full flex gap-14 flex-col sm:w-full md:w-full lg:w-4/5 xl:w-5/6 px-2 md:px-0">
        {/* Card  */}
        <div className="flex items-center gap-10 justify-evenly flex-wrap"
        >
          {cardData.cards.map((data, index) => (
            <div
              key={index}
              className="w-[300px] bg-[#374151] p-5 rounded-md flex flex-col justify-center items-center shadow-md "
            >
              {/* Heading */}
              <div>
                <h3 className="text-white text-[18px]">{data.title}</h3>
              </div>
              {/* Content */}
              <div
                className={`overflow-y-auto  h-[80px] no-scrollbar ${
                  viewMoreStates[index]
                    ? " h-[80px] overflow-y-auto"
                    : "overflow-hidden"
                }`}
              >
                <p className="text-[14px] text-center text-white">
                  {data.message}
                </p>
              </div>
              <span>
                {viewMoreStates[index] ? (
                  <span className="text-[#969ca6]">
                    <button onClick={() => toggleViewMore(index)}>View Less</button>
                  </span>
                ) : (
                  <span className="text-[#969ca6]">
                    <button onClick={() => toggleViewMore(index)}>View More</button>
                  </span>
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Card_Mission;
